import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import { saveAs } from "file-saver";
import moment from "moment";
import HistoryIcon from "@material-ui/icons/History";
import {
  getProfilesByUser,
  updateProfile,
  getProfile,
} from "../../actions/profile";
import ThermalSalesReport from "./ThermalSalesReport";
import ThermalSalesReportIMIN from "./ThermalSalesReportIMIN";
import {
  useMediaQuery,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  IconButton,
  Container,
  TextField,
  CircularProgress,
  FormControl,
  makeStyles,
  useTheme,
  createTheme,
  ThemeProvider,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Card,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import PropTypes from "prop-types";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import ClearIcon from "@material-ui/icons/Clear";
import { getAllClients } from "../../actions/clientActions";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import RemoveRedEyeOutlinedIcon from "@material-ui/icons/RemoveRedEyeOutlined";
import Autocomplete from "@material-ui/lab/Autocomplete";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { AppContext } from "../../Context/AppContext";
import { useLocation } from "react-router-dom";
import usePermissions from "../../utils/permissions";
import * as api from "../../api/index";

import ProgressButton from "react-progress-button";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DSRDialog from "./DSRDialog";
import DateFnsUtils from "@date-io/date-fns";
import {
  deleteInvoice,
  getInvoicesByUser,
  getInvoices,
  softdeleteInvoice,
} from "../../actions/invoiceActions";
import { getUsers } from "../../actions/auth";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import { useSnackbar } from "react-simple-snackbar";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import GetAppIcon from "@material-ui/icons/GetApp";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles((theme) => ({
  table: {
    minWidth: 500,
  },

  tablecell: {
    fontSize: "16px",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "20px",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  typography: {
    fontSize: "18px",
    fontWeight: 500,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
}));

const tableStyle = {
  width: 160,
  fontSize: 14,
  cursor: "pointer",
  borderBottom: "none",
  padding: "8px",
  textAlign: "center",
};
const headerStyle = { borderBottom: "none", textAlign: "center" };
const colorTheme = createTheme({
  palette: {
    primary: {
      main: "#ef7f1a",
    },
  },
});

const Invoices = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [downloadStatus, setDownloadStatus] = useState(null);
  const user = JSON.parse(localStorage.getItem("profile"));
  const { profiles } = useSelector((state) => state.profiles);
  // const invoices = useSelector((state) => state.invoices.invoices);
  const { invoices, deletedInvoices } = useSelector((state) => state.invoices);
  const {
    openDSR,
    setOpenDSR,
    dateDSR,
    setDateDSR,
    showPreviewDSR,
    setShowPreviewDSR,
  } = useContext(AppContext);
  // //(invoices);
  const [rows, setRows] = useState([]);
  const { users } = useSelector((state) => state.auth);
  const clients = useSelector((state) => state.clients.clients);
  // //(users);
  // //(rows);
  const [loading, setLoading] = useState(false);
  const isLoading = useSelector((state) => state.invoices.isLoading);
  const [printIMINReport, setPrintIMINReport] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [salesperson, setSalesperson] = useState(null);
  const [party, setParty] = useState(null);
  const [paymentMode, setPaymentMode] = useState("");
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("");
  // Use permissions hook
  const {
    loading: permissionsLoading,
    canUpdatePage,
    canDeletePage,
    isAdmin,
  } = usePermissions();

  const handleInvoiceReprint = () => {
    console.log("Bill Preview Click");
    setPrintIMINReport(true);

    setTimeout(() => {
      setPrintIMINReport(false);
    }, 3500);
    //console.log("Print Invoice State",printInvoice);
  };
  // const rows = []

  // State for permissions and loading
  const [canDownloadReports, setcanDownloadReports] = useState(false);
  const [isAdminn, setIsAdminn] = useState(false);
  const [loadingg, setLoadingg] = useState(true);

  // Fetch permissions from database
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const profile = JSON.parse(localStorage.getItem("profile")) || {};
        if (!profile.token) throw new Error("No token found");
        setIsAdminn(profile?.result?.userType?.includes("admin") || false);

        const { data } = await api.getUserPermissions();
        setcanDownloadReports(data.canDownloadPdfReports || false);
        setLoadingg(false);
      } catch (error) {
        console.error("Error fetching permissions:", error.message);
        setcanDownloadReports(false); // Fallback to no permission
        setLoadingg(false);
      }
    };
    fetchPermissions();
  }, []);

  useEffect(() => {
    dispatch(getInvoices());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getInvoices());

    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    // dispatch(getProfilesByUser({ search: user?.result?._id }))
    dispatch(getProfile(user?.userProfile?._id));
  }, [location, dispatch]);
  useEffect(() => {
    if (user?.result?.userType === "user") {
      const rows = invoices.filter(
        (inv) => inv.creator[0] === user?.result?._id
      );
      setRows(rows);
    } else {
      setRows(invoices);
    }

    // eslint-disable-next-line
  }, [invoices]);

  // // Step 1: Fetch all invoices for both admins and non-admins
  // // Why: Ensure both see the same data, controlled by permissions later
  // useEffect(() => {
  //   dispatch(getInvoices());
  // }, [location, dispatch]);

  // useEffect(() => {
  //   dispatch(getProfile(user?.userProfile?._id));
  // }, [location, dispatch]);

  // // Step 2: Set rows to all invoices without filtering
  // // Why: Non-admins should see all invoices, not just their own
  // useEffect(() => {
  //   console.log("All Invoices from Redux:", invoices);
  //   console.log("Logged-in User:", user);
  //   setRows(invoices);
  // }, [invoices]);

  useEffect(() => {
    dispatch(getUsers());
  }, [location]);
  useEffect(() => {
    dispatch(
      // getClientsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllClients()
    );

    // eslint-disable-next-line
  }, [dispatch]);
  const toCommas = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  // useEffect(() => {
  //   if (user?.result?.userType === "user") {
  //     const rows = invoices.filter(
  //       (inv) => inv.creator[0] === user?.result?._id
  //     );
  //     setRows( rows.filter(filterByDateRange));
  //   } else {
  //     setRows(invoices.filter(filterByDateRange));
  //   }
  // }, );

  const handleDateChange = (newDate) => {
    setDateDSR(newDate);
    setShowPreviewDSR(false);
  };

  const handleSubmit = () => {
    setShowPreviewDSR(true);
  };

  const handleClose = () => {
    setOpenDSR(false);
    setShowPreviewDSR(false);
  };
  const findUserNameById = (userId) => {
    // //("parameter" + userId);
    const user = users.find((user) => user._id == userId);
    // //(user);
    return user ? user.name : "";
  };

  const filterByDateRange = (invoice) => {
    if (!startDate || !endDate) return true;
    const invoiceDate = moment(invoice.createdAt);
    return invoiceDate.isBetween(startDate, endDate, "day", "[]");
  };
  const filteredRows = rows.filter((row) => {
    const isSalespersonFilter = selectedFilter === "salesperson";
    const isPaymentModeFilter = selectedFilter === "paymentMode";
    const searchQueryLowerCase =
      searchQuery && typeof searchQuery === "string"
        ? searchQuery.toLowerCase()
        : "";

    if (isSalespersonFilter) {
      const creatorName = findUserNameById(row.creator).toLowerCase();
      return (
        filterByDateRange(row) && creatorName.includes(searchQueryLowerCase)
      );
    } else if (isPaymentModeFilter) {
      const paymentMode = row.paymentMode.toLowerCase();
      console.log("Payment Mode", paymentMode);
      return (
        filterByDateRange(row) && paymentMode.includes(searchQueryLowerCase)
      );
    } else {
      // const clientName = row.client.name.toLowerCase() || "Customer";
      const clientName = (row?.client?.name || "Customer").toLowerCase();

      return (
        filterByDateRange(row) && clientName.includes(searchQueryLowerCase)
      );
    }
  });
  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value); // Update the selected filter when the user changes the option
  };
  const editInvoice = (id) => {
    history.push(`/edit/invoice/${id}`);
  };
  const handlesoftDelete = (id) => {
    // Find the invoice to check its payment mode
    const invoiceToDelete = rows.find((row) => row._id === id);

    // Check if payment mode is "Credit"
    if (invoiceToDelete?.paymentMode?.toLowerCase() === "credit") {
      alert("Warning: Credit invoices cannot be deleted!");
      return;
    }

    // Proceed with deletion if not Credit
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this invoice?"
    );
    if (confirmDelete) {
      dispatch(softdeleteInvoice(id, openSnackbar));
      openSnackbar("Invoice deleted successfully");
    }
  };
  // const handleDelete = (id) => {
  //   const confirmDelete = window.confirm(
  //     "Are you sure you want to delete this client?"
  //   );
  //   if (confirmDelete) {
  //     dispatch(deleteInvoice(id, openSnackbar));
  //   }
  // };

  const openInvoice = (id) => {
    history.push(`/invoice/${id}`);
  };
  const createAndDownloadPdf = () => {
    //(rows);
    //(filteredRows);
    setLoading(true);
    // debugger;
    if (filteredRows.length) {
      setDownloadStatus("loading");
      axios
        .post(`${process.env.REACT_APP_API}/create-report`, {
          profile: user.userProfile,
          logo: profiles.logo,
          fromDate: startDate,
          toDate: endDate,
          filteredRows,
          users,
        })
        .then(() =>
          axios.get(`${process.env.REACT_APP_API}/fetch-report`, {
            responseType: "blob",
          })
        )
        .then((res) => {
          const pdfBlob = new Blob([res.data], { type: "application/pdf" });
          // const downloadUrl = window.URL.createObjectURL(pdfBlob);
          // setDownloadStatus("success");
          // window.open(downloadUrl, "_blank");
          const currentDate = new Date();

          saveAs(pdfBlob, `OrderReport${currentDate}.pdf`);
          const downloadUrl = `${process.env.REACT_APP_URL}/files/Exported-Reports/report.pdf`;
          window.open(downloadUrl, "_blank");
          setLoading(false);
          setDownloadStatus("success");
        });
    } else {
      openSnackbar("No record to Export");
    }
  };
  const handleClientNameClick = (id) => {
    history.push(`/stats/${id}`);
  };
  if (!user) {
    history.push("/login");
  }

  const handleStartDateChange = (date) => {
    // const formattedDate = date.toISOString().split("T")[0];
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    // const formattedDate = date.toISOString().split("T")[0];
    setEndDate(date);
  };
  const totalAmount = filteredRows.reduce((total, row) => {
    // Ensure that each row has an 'amount' property
    if (typeof row.total === "number") {
      return total + row.total;
    } else {
      return total;
    }
  }, 0);
  const salespersonsProps = {
    options: users,
    getOptionLabel: (option) => option.name,
  };
  // }
  function checkStatus(status) {
    return status === "Partial"
      ? {
          border: "solid 0px #1976d2",
          backgroundColor: "#baddff",
          padding: "8px 18px",
          borderRadius: "20px",
        }
      : status === "Paid"
      ? {
          border: "solid 0px green",
          backgroundColor: "#a5ffcd",
          padding: "8px 18px",
          borderRadius: "20px",
        }
      : status === "Due"
      ? {
          border: "solid 0px red",
          backgroundColor: "#ffaa91",
          padding: "8px 18px",
          borderRadius: "20px",
        }
      : status === "" || status === undefined || status === null
      ? {
          border: "solid 0px red",
          backgroundColor: "#ffaa91",
          padding: "8px 18px",
          borderRadius: "20px",
        }
      : "red";
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (rows.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
          margin: "80px",
        }}
      >
        <NoData />
        <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
          No Order yet. Click the plus icon to create Order
        </p>
      </div>
    );
  }
  const clientsProps = {
    options: clients,
    getOptionLabel: (option) => option.name,
  };
  return (
    <div
      style={{
        minHeight: isMobile ? "740px" : "470px",
      }}
    >
      <ThemeProvider theme={colorTheme}>
        <Container
          style={{
            width: isMobile ? "100%" : "85%",
            paddingTop: "2px",
            paddingBottom: "2px",
            border: "none",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  label="From"
                  name="FromDate"
                  value={startDate}
                  onChange={handleStartDateChange}
                  required
                  format="yyyy/MM/dd"
                  style={{ maxWidth: isMobile ? "50%" : "100%" }}
                />

                <KeyboardDatePicker
                  label="To"
                  name="EndDate"
                  value={endDate}
                  onChange={handleEndDateChange}
                  required
                  format="yyyy/MM/dd"
                  style={{ maxWidth: "50%" }}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <FormControl style={{ width: "100px" }}>
                <InputLabel>Filter:</InputLabel>
                <Select
                  value={selectedFilter}
                  onChange={(event) => handleFilterChange(event)} // Provide the event object
                >
                  <MenuItem value="salesperson">Filter by Store</MenuItem>
                  <MenuItem value="customer">Filter by Customer</MenuItem>
                  <MenuItem value="paymentMode">
                    Filter by Payment Mode
                  </MenuItem>
                </Select>
                {selectedFilter && (
                  <IconButton
                    size="small"
                    style={{
                      marginLeft: "8px",
                      backgroundColor: "transparent",

                      color: "#ef7f1a",
                      borderRadius: "4px",
                    }}
                    onClick={() => {
                      setSelectedFilter("");
                      setSearchQuery("");
                      setSalesperson("");
                      setParty("");
                      setPaymentMode("");
                    }}
                  >
                    <ClearIcon />
                  </IconButton>
                )}
              </FormControl>
              {selectedFilter && (
                <div>
                  {/* Display filtering results or perform filtering logic based on selectedFilter */}
                  {selectedFilter === "salesperson" ? (
                    <ThemeProvider theme={colorTheme}>
                      <Container>
                        {salesperson && (
                          <div
                            style={{
                              display: "flex",
                              marginTop: "20px",
                              gap: "5px",
                              height: "50px",
                            }}
                          >
                            <Typography variant="subtitle1" gutterBottom>
                              {salesperson.name}
                            </Typography>

                            <Button
                              color="primary"
                              size="small"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#ef7f1a",
                                color: "white",
                              }}
                              onClick={() => {
                                setSalesperson(null);
                                setSearchQuery("");
                              }}
                            >
                              Change
                            </Button>
                          </div>
                        )}
                        <div
                          style={
                            salesperson
                              ? { display: "none" }
                              : { display: "block", width: "200px" }
                          }
                        >
                          <Autocomplete
                            {...salespersonsProps}
                            // PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // required={!invoice && true}
                                label="Select Sales Person"
                                margin="normal"
                                variant="outlined"

                                // error={touched && !!errors.client}
                                // helperText={touched && errors.client}
                              />
                            )}
                            value={users?.name}
                            onChange={(event, value) => {
                              setSalesperson(value);
                              setSearchQuery(value ? value.name : "");

                              console.log("value: ", value);
                              // handleClientChange();
                            }}
                            // onChange={(event, value) => setClient(value) }
                          />
                        </div>
                      </Container>
                    </ThemeProvider>
                  ) : selectedFilter === "customer" ? (
                    <ThemeProvider theme={colorTheme}>
                      <Container>
                        {party && (
                          <div
                            style={{
                              display: "flex",
                              marginTop: "20px",
                              gap: "10px",
                              height: "50px",
                            }}
                          >
                            <Typography variant="subtitle1" gutterBottom>
                              {party.name}
                            </Typography>

                            <Button
                              color="primary"
                              size="small"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#ef7f1a",
                                color: "white",
                              }}
                              onClick={() => {
                                setParty(null);
                                setSearchQuery("");
                              }}
                            >
                              Change
                            </Button>
                          </div>
                        )}
                        <div
                          style={
                            party
                              ? { display: "none" }
                              : { display: "block", width: "200px" }
                          }
                        >
                          <Autocomplete
                            {...clientsProps}
                            // PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // required={!invoice && true}
                                label="Select Customer"
                                margin="normal"
                                variant="outlined"
                                // error={touched && !!errors.client}
                                // helperText={touched && errors.client}
                              />
                            )}
                            value={clients?.name}
                            onChange={(event, value) => {
                              setParty(value);
                              setSearchQuery(value ? value.name : "");

                              // handleClientChange();
                            }}
                            // onChange={(event, value) => setClient(value) }
                          />
                        </div>
                      </Container>
                    </ThemeProvider>
                  ) : selectedFilter === "paymentMode" ? (
                    <div style={{ marginTop: "6.5px" }}>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <InputLabel id="demo-simple-select-outlined-label">
                          Payment Mode
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={paymentMode}
                          required={true}
                          onChange={(e, value) => {
                            // console.log("Invoice.js me  signature console.log",signatureDataUrl)
                            setPaymentMode(e.target.value);
                            setSearchQuery(e.target.value);
                          }}
                          label="Payment Method"
                        >
                          <MenuItem value="Select">
                            <em>None</em>
                          </MenuItem>
                          <MenuItem value="Cash">Cash</MenuItem>
                          <MenuItem value="Online">Online</MenuItem>
                          <MenuItem value="Credit">Credit</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  ) : null}
                </div>
              )}
              {/* {user?.result?.userType !== "admin" && (
                <ThemeProvider theme={colorTheme}>
                  <Container>
                    {party && (
                      <div
                        style={{
                          display: "flex",
                          marginTop: "20px",
                          gap: "10px",
                          height: "50px",
                        }}
                      >
                        <Typography variant="subtitle1" gutterBottom>
                          {party.name}
                        </Typography>

                        <Button
                          color="primary"
                          size="small"
                          style={{
                            textTransform: "none",
                            backgroundColor: "#ef7f1a",
                            color: "white",
                          }}
                          onClick={() => {
                            setParty(null);
                            setSearchQuery("");
                          }}
                        >
                          Change
                        </Button>
                      </div>
                    )}
                    <div
                      style={
                        party
                          ? { display: "none" }
                          : { display: "block", width: "200px" }
                      }
                    >
                      <Autocomplete
                        {...clientsProps}
                        // PaperComponent={CustomPaper}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            // required={!invoice && true}
                            label="Select Customer"
                            margin="normal"
                            variant="outlined"
                            // error={touched && !!errors.client}
                            // helperText={touched && errors.client}
                          />
                        )}
                        value={clients?.name}
                        onChange={(event, value) => {
                          setParty(value);
                          setSearchQuery(value ? value.name : "");

                          // handleClientChange();
                        }}
                        // onChange={(event, value) => setClient(value) }
                      />
                    </div>
                  </Container>
                </ThemeProvider>
              )} */}

              {loading ? (
                <CircularProgress
                  style={{ marginTop: "20px", marginLeft: "10px" }}
                />
              ) : (
                <Button
                  variant="outlined"
                  endIcon={<GetAppIcon />}
                  onClick={createAndDownloadPdf}
                  style={{
                    margin: "16px 0 8px 0",
                    height: "50px",
                  }}
                >
                  PDF
                </Button>
              )}
              {/* {printIMINReport && (
                <div
                  style={{
                    position: "absolute",
                    left: "-9999px",
                    top: "-9999px",
                  }}
                >
                  <ThermalSalesReportIMIN
                    userProfile={user.userProfile}
                    salesData={{
                      invoices: rows, // Pass all invoices, component will filter by date
                      isPrintReport: true,
                    }}
                    selectedDate={date}
                  />
                </div>
              )} */}

              <Button
                variant="outlined"
                color="primary"
                onClick={() => setOpenDSR(true)}
                disabled={loadingg || (!isAdminn && !canDownloadReports)}
                style={{
                  margin: "16px 0 8px 0",
                  height: "50px",
                  cursor:
                    loadingg || (!isAdminn && !canDownloadReports)
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                Sales Report
              </Button>

              <Button
                variant="outlined"
                color="primary"
                startIcon={<HistoryIcon />}
                onClick={() => history.push("/invoices/deleted")}
                style={{ margin: "16px 0 8px 0", height: "50px" }}
              >
                View Delete History
              </Button>

              {/* <Dialog
                open={openDSR}
                onClose={handleClose}
                classes={{ paper: classes.dialogPaper }}
              >
                <DialogTitle>Daily Sales Report</DialogTitle>
                <DialogContent>
                  <div className={classes.controls}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        margin="normal"
                        label="Select Date"
                        format="dd/MM/yyyy"
                        value={dateDSR}
                        onChange={handleDateChange}
                        className={classes.datePicker}
                      />
                    </MuiPickersUtilsProvider>

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                    >
                      Generate Preview
                    </Button>
                  </div>

                  {showPreviewDSR && (
                    <Card className={classes.previewCard}>
                      <ThermalSalesReport
                        userProfile={user.userProfile}
                        salesData={{
                          invoices: rows, // Pass all invoices, component will filter by date
                          isPrintReport: true,
                        }}
                        selectedDate={date}
                      />
                      <ThermalSalesReportIMIN
                        userProfile={user.userProfile}
                        salesData={{
                          invoices: rows, // Pass all invoices, component will filter by date
                          isPrintReport: true,
                        }}
                        selectedDate={dateDSR}
                      />
                    </Card>
                  )}
                </DialogContent>
              </Dialog> */}
              <DSRDialog
                open={openDSR}
                onClose={handleClose}
                date={dateDSR}
                handleDateChange={handleDateChange}
                handleSubmit={handleSubmit}
                showPreview={showPreviewDSR}
                rows={rows}
                user={user}
                classes={classes}
              />

              {/* <ThermalSalesReport
                userProfile={user.userProfile}
                salesData={{
                  invoices: rows, // Pass all invoices, component will filter by date
                  isPrintReport: true,
                }}
              /> */}
            </div>
            {((startDate && endDate) ||
              salesperson ||
              party ||
              paymentMode) && (
              <div
                className={classes.textContainer}
                style={{ margin: isMobile ? "0" : "10px 0 0 2rem" }}
              >
                <Typography variant="h6" className={classes.typography}>
                  Orders Count: {filteredRows.length}
                </Typography>

                <Typography variant="h6" className={classes.typography}>
                  Total Orders MRP: ฿{toCommas(totalAmount.toFixed(2))}
                </Typography>
              </div>
            )}
          </div>

          <TableContainer component={Paper} elevation={0}>
            <Table
              className={classes.table}
              aria-label="custom pagination table"
            >
              <TableHead>
                <TableRow>
                  <TableCell style={headerStyle}>Invoice Number</TableCell>

                  <TableCell style={headerStyle}>Date</TableCell>
                  <TableCell style={headerStyle}>Payment Mode</TableCell>
                  <TableCell style={headerStyle}>Customer</TableCell>
                  <TableCell style={headerStyle}>Invoice Amount</TableCell>
                  {/* <TableCell style={headerStyle}>Due Date</TableCell> */}

                  <TableCell style={headerStyle}>Status</TableCell>
                  {/* {user?.result?.userType === "admin" && ( */}
                  <TableCell style={headerStyle}>Store</TableCell>
                  {/* )} */}
                  {/* <TableCell style={headerStyle}>View</TableCell> */}

                  <TableCell style={headerStyle}>Edit</TableCell>

                  {/* {user?.result?.userType === "admin" && ( */}
                  <TableCell style={headerStyle}>Delete</TableCell>
                  {/* )} */}

                  {/* {(user?.result?.userType === "admin" ||
                    user?.result?.permissions?.canEdit) && (
                    <TableCell style={headerStyle}>Edit</TableCell>
                  )} */}
                </TableRow>
              </TableHead>

              <TableBody>
                {(rowsPerPage > 0
                  ? filteredRows.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : filteredRows
                ).map((row) => (
                  <TableRow key={row._id} style={{ cursor: "pointer" }}>
                    <TableCell
                      style={tableStyle}
                      onClick={() => openInvoice(row._id)}
                    >
                      {" "}
                      {row.invoiceNumber}{" "}
                    </TableCell>
                    <TableCell
                      style={tableStyle}
                      onClick={() => openInvoice(row._id)}
                    >
                      {" "}
                      {moment(row.createdAt).format("MMM Do YYYY")}{" "}
                    </TableCell>
                    <TableCell
                      style={tableStyle}
                      onClick={() => openInvoice(row._id)}
                    >
                      {row.paymentMode}{" "}
                    </TableCell>
                    <TableCell style={tableStyle}>
                      {" "}
                      {row?.client?.name ? row.client.name : "Cash"}{" "}
                    </TableCell>
                    <TableCell
                      style={tableStyle}
                      onClick={() => openInvoice(row._id)}
                    >
                      {row.currency}{" "}
                      {row.total ? toCommas(row.total.toFixed(2)) : row.total}{" "}
                    </TableCell>
                    {/* <TableCell style={tableStyle} onClick={() => openInvoice(row._id)}>
                    {" "}
                    {moment(row.dueDate).fromNow()}{" "}
                  </TableCell> */}
                    {/* <TableCell style={tableStyle}>
                      {" "}
                      <button style={checkStatus(row.status)}>
                        {row.status}
                      </button>
                    </TableCell> */}
                    <TableCell
                      style={{
                        ...tableStyle, // Spread the existing table styles
                        cursor: "pointer", // Add pointer cursor
                      }}
                      onClick={() => openInvoice(row._id)}
                    >
                      <button
                        style={{
                          ...checkStatus(row.status), // Spread the styles from checkStatus
                          cursor: "pointer", // Add pointer style
                        }}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the TableCell's onClick from triggering
                          openInvoice(row._id);
                        }}
                      >
                        {row.status}
                      </button>
                    </TableCell>

                    <TableCell
                      style={tableStyle}
                      onClick={() => openInvoice(row._id)}
                    >
                      {" "}
                      {findUserNameById(row.creator)} {/* {row.creator} */}
                    </TableCell>
                    {/* <TableCell style={tableStyle}>
                    {" "}
                    <IconButton onClick={() => openInvoice(row._id)}>
                      <RemoveRedEyeOutlinedIcon
                        style={{ width: "20px", height: "20px" }}
                      />
                    </IconButton>
                  </TableCell> */}

                    <TableCell style={{ ...tableStyle, width: "10px" }}>
                      <IconButton
                        onClick={() => editInvoice(row._id)}
                        disabled={
                          permissionsLoading ||
                          (!isAdmin() && !canUpdatePage("Invoice"))
                        }
                        style={{
                          cursor:
                            permissionsLoading ||
                            (!isAdmin() && !canUpdatePage("Invoice"))
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <BorderColorIcon
                          style={{ width: "20px", height: "20px" }}
                        />
                      </IconButton>
                    </TableCell>
                    <TableCell style={{ ...tableStyle, width: "10px" }}>
                      <IconButton
                        disabled={
                          permissionsLoading ||
                          (!isAdmin() && !canDeletePage("Invoice"))
                        }
                        onClick={() => handlesoftDelete(row._id)}
                        style={{
                          cursor:
                            permissionsLoading ||
                            (!isAdmin() && !canDeletePage("Invoice"))
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <DeleteOutlineRoundedIcon
                          style={{ width: "20px", height: "20px" }}
                        />
                      </IconButton>
                    </TableCell>
                    {/* <TableCell style={{ ...tableStyle, width: "10px" }}>
                      <IconButton
                        disabled={
                          permissionsLoading ||
                          (!isAdmin() && !canDeletePage("Invoice"))
                        }
                        onClick={() => handleDelete(row._id)}
                        style={{
                          cursor:
                            permissionsLoading ||
                            (!isAdmin() && !canDeletePage("Invoice"))
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <DeleteOutlineRoundedIcon
                          style={{ width: "20px", height: "20px" }}
                        />
                      </IconButton>
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[
                      5,
                      10,
                      25,
                      { label: "All", value: -1 },
                    ]}
                    colSpan={6}
                    count={filteredRows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { "aria-label": "rows per page" },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Container>
      </ThemeProvider>
    </div>
  );
};

export default Invoices;
